import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WarningIcon from '@mui/icons-material/Warning';

const TrainingSchedulePage = () => {
  const pdfUrl = 'https://api.insbu.bi/storage/documents/01KYCF01RDQQZ4D0Q7K7XD5ETD.pdf';

  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        {/* En-tête de l'article */}
        <header style={styles.header}>
          {/* Badges */}
          <div style={styles.badges}>
            <span style={styles.badgeRed}>INSBU</span>
            <span style={styles.badgeGreen}>RPPCUB</span>
            <span style={styles.badgeGray}>Actualité</span>
          </div>

          {/* Titre principal */}
          <h1 style={styles.title}>
            RPPCUB 2026 : Les dates et lieux de formation enfin dévoilés
          </h1>

          {/* Sous‑titre – introduit pour enrichir la hiérarchie */}
          <p style={styles.subtitle}>
            Le calendrier définitif des sessions de formation pour les agents recenseurs du RPPCUB 2026
          </p>

          {/* Méta‑informations */}
          <div style={styles.meta}>
            <span style={styles.metaItem}>
              <CalendarTodayIcon style={styles.metaIcon} /> Publié le 25 juillet 2026
            </span>
            <span style={styles.metaItem}>
              <LocationOnIcon style={styles.metaIcon} /> Burundi
            </span>
            <span style={styles.metaItem}>
              <AccessTimeIcon style={styles.metaIcon} /> Lecture 2 min
            </span>
          </div>

          {/* Chapeau – introduction forte */}
          <p style={styles.chapeau}>
            Après la présélection des agents et le lancement officiel de l'opération, l'INSBU publie le calendrier définitif des formations. Tous les candidats présélectionnés sont tenus de consulter d'urgence les dates et lieux attribués à leur commune. Les sessions débutent impérativement à 08h00.
          </p>
        </header>

        {/* Corps de l'article */}
        <article style={styles.article}>
          
          {/* SECTION 1 */}
          <h2 style={styles.h2}>1. Une phase cruciale pour la collecte de données</h2>
          <p style={styles.p}>
            La Direction Générale de l’INSBU informe les candidats présélectionnés au poste d’agents recenseurs qu’ils doivent impérativement participer aux sessions de formation et aux tests de sélection finale. Ces formations sont la dernière étape avant le déploiement sur le terrain pour le <strong>Recensement des Propriétaires des Propriétés/Parcelles dans les centres urbains du Burundi (RPPCUB)</strong>.
          </p>

          {/* SECTION 2 */}
          <h2 style={styles.h2}>2. Calendrier par commune</h2>
          <p style={styles.p}>
            Les formations sont réparties selon les communes pour faciliter l’accès des candidats.
          </p>

          <div style={styles.infoBlock}>
            <p style={styles.p}>
              <strong>Pour les agents recenseurs :</strong> les sessions se tiendront du <strong>28 au 31 juillet 2026</strong> pour les communes de <strong>Ngozi, Rumonge et Gitega</strong> ; et du <strong>3 au 6 (ou 7) août 2026</strong> pour <strong>Ntahangwa, Mugere et Mukaza</strong>.
            </p>
            <p style={styles.p}>
              <strong>Pour les chefs d’équipes (retenus après sélection) :</strong> des sessions spécifiques sont prévues les <strong>1er, 7 et 8 août 2026</strong> selon les communes.
            </p>
          </div>

          {/* Encadré des lieux – sans émoji, avec icône React */}
          <div style={styles.lieuxBox}>
            <p style={styles.lieuxTitle}>
              <LocationOnIcon style={styles.lieuxIcon} /> Lieux de formation
            </p>
            <ul style={styles.lieuxList}>
              <li style={styles.lieuxItem}><strong>Ngozi</strong> – Hôtel Ombre des Patriotes (HOPA)</li>
              <li style={styles.lieuxItem}><strong>Rumonge</strong> – Galaxy Hotel</li>
              <li style={styles.lieuxItem}><strong>Gitega</strong> – Sunset Hotel</li>
              <li style={styles.lieuxItem}><strong>Ntahangwa</strong> – Espace Isaganirizo (ESIS)</li>
              <li style={styles.lieuxItem}><strong>Mugere</strong> – Tiger's Appartement</li>
              <li style={styles.lieuxItem}><strong>Mukaza</strong> – CEPRODILIC</li>
            </ul>
            <p style={styles.lieuxNote}>Tous les détails sont également disponibles dans le PDF ci‑dessous.</p>
          </div>

          {/* SECTION 3 */}
          <h2 style={styles.h2}>3. Point d’attention majeur</h2>
          <div style={styles.attentionBox}>
            <WarningIcon style={styles.attentionIcon} />
            <p style={styles.attentionText}>
              L’INSBU insiste sur la <strong>ponctualité</strong>. Toutes les sessions débutent à <strong>08h00 précises</strong>. Tout retard pourra être considéré comme un désistement. Les candidats sont invités à vérifier leur lieu de formation dès maintenant.
            </p>
          </div>

          {/* SECTION 4 */}
          <h2 style={styles.h2}>4. Téléchargement de la note officielle</h2>
          <p style={styles.p}>
            Pour plus de détails, veuillez consulter la note de service N° 121/114.10/HF/DG/INSBU/2026 en cliquant sur le lien ci‑dessous.
          </p>

          <div style={styles.pdfContainer}>
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer" style={styles.pdfButton}>
              <PictureAsPdfIcon style={styles.pdfIcon} />
              Télécharger / consulter la note de service (PDF)
            </a>
          </div>

          {/* Signature de l'article */}
          <div style={styles.signature}>
            <p>— Publié par l'INSBU —</p>
          </div>

        </article>
      </main>

      <Footer />
    </div>
  );
};

// Styles professionnels – presse en ligne
const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '820px',
    margin: '0 auto',
    padding: '40px 20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '30px',
    borderBottom: '2px solid #e0e0e0',
  },
  badges: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  badgeRed: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGreen: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGray: {
    backgroundColor: '#6c757d',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  title: {
    color: '#1a1a1a',
    fontSize: '2.4rem',
    fontWeight: '700',
    lineHeight: 1.2,
    marginBottom: '8px',
    letterSpacing: '-0.3px',
  },
  subtitle: {
    fontSize: '1.1rem',
    fontWeight: '300',
    color: '#4a4a4a',
    marginBottom: '18px',
    letterSpacing: '0.2px',
  },
  meta: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '25px',
    fontSize: '0.9rem',
    color: '#6c757d',
  },
  metaItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  metaIcon: {
    fontSize: '1rem',
    color: '#008D36',
  },
  chapeau: {
    fontSize: '1.25rem',
    lineHeight: 1.7,
    color: '#2c3e50',
    maxWidth: '700px',
    margin: '0 auto',
    fontStyle: 'italic',
    fontWeight: '400',
    borderLeft: '4px solid #008D36',
    paddingLeft: '20px',
    textAlign: 'left',
  },
  article: {
    backgroundColor: 'white',
    padding: '40px 45px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
    marginBottom: '40px',
  },
  h2: {
    color: '#008D36',
    fontSize: '1.6rem',
    fontWeight: '600',
    marginTop: '40px',
    marginBottom: '16px',
    paddingBottom: '6px',
    borderBottom: '2px solid #eaeaea',
  },
  p: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '20px',
    textAlign: 'justify',
  },
  infoBlock: {
    backgroundColor: '#f8fafc',
    padding: '20px 25px',
    borderRadius: '8px',
    borderLeft: '4px solid #008D36',
    marginBottom: '25px',
  },
  lieuxBox: {
    backgroundColor: '#f0f7f4',
    padding: '20px 25px',
    borderRadius: '8px',
    border: '1px solid #d0e6dc',
    marginBottom: '30px',
  },
  lieuxTitle: {
    fontWeight: '700',
    fontSize: '1.05rem',
    color: '#008D36',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  lieuxIcon: {
    fontSize: '1.3rem',
    color: '#008D36',
  },
  lieuxList: {
    listStyle: 'none',
    padding: 0,
    margin: '8px 0 12px 0',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '6px 20px',
  },
  lieuxItem: {
    fontSize: '0.95rem',
    lineHeight: 1.6,
    color: '#1e1e1e',
  },
  lieuxNote: {
    fontSize: '0.9rem',
    color: '#4a6a5a',
    marginTop: '10px',
    fontStyle: 'italic',
  },
  attentionBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backgroundColor: '#fef3f2',
    padding: '18px 22px',
    borderRadius: '8px',
    border: '1px solid #f5c6cb',
    marginBottom: '30px',
  },
  attentionIcon: {
    fontSize: '1.6rem',
    color: '#E30613',
    flexShrink: 0,
    marginTop: '2px',
  },
  attentionText: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: '#721c24',
  },
  pdfContainer: {
    textAlign: 'center',
    margin: '30px 0 20px',
  },
  pdfButton: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#008D36',
    color: 'white',
    padding: '14px 32px',
    borderRadius: '50px',
    fontSize: '1.05rem',
    fontWeight: '600',
    textDecoration: 'none',
    transition: 'background-color 0.25s, transform 0.15s',
    boxShadow: '0 4px 12px rgba(0,141,54,0.25)',
    cursor: 'pointer',
    border: 'none',
  },
  pdfIcon: {
    marginRight: '12px',
    fontSize: '1.6rem',
  },
  signature: {
    textAlign: 'center',
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #eaeaea',
    color: '#6c757d',
    fontSize: '0.9rem',
    letterSpacing: '0.3px',
  },
};

export default TrainingSchedulePage;